/**
 * Checks if the application is running in an Electron environment.
 *
 * @returns true if running in Electron app, false if running in browser
 */
export const isElectronApp = (): boolean => {
  return typeof window !== "undefined" && window.electronAPI !== undefined;
};

/**
 * Checks if Windows domain credential caching is available in the current
 * environment. This is only true when running inside an Electron app version
 * that exposes the `cacheDomainCredentials` hook. Use this to feature-gate the
 * Amazon Account Caching step so it only appears when the native capability is
 * present (and stays hidden on older Electron builds and in the browser).
 *
 * @returns true if the cacheDomainCredentials hook is available
 */
export const isCredentialCachingAvailable = (): boolean => {
  return (
    typeof window !== "undefined" &&
    !!window.electronAPI &&
    typeof window.electronAPI.cacheDomainCredentials === "function"
  );
};
